// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Util from './mixin/utility'
import utilityMixin from './mixin/utilityMixin'
import DateUtil from './mixin/dateUtilityMixin'
import axios from 'axios'
import VueAxios from "vue-axios";
import connServer from "./mixin/connServer";
import VueLocalStorage from 'vue-localstorage'
import moment from 'moment'


import '@/assets/css/ress.css'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/common.css'
import '@/assets/css/layout.css'
import '@/assets/css/style.css'
import '@/assets/css/utill.css'
import ElementUI from 'element-ui'
import contextMenu from 'vue-context-menu'
import VueCookies from 'vue-cookies';

import locale from 'element-ui/lib/locale/lang/ja'


// 
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(ElementUI, { locale })
//
Vue.use(VueLocalStorage)
Vue.use(contextMenu)
Vue.use(VueCookies);

// 
Vue.store = store
// axios
Vue.use(VueAxios, axios);
Vue.config.productionTip = false
Vue.axios.defaults.withCredentials = true;
Vue.axios.defaults.headers.common["Accept"] = "application/json";
Vue.axios.defaults.headers.common["Content-Type"] = "application/json";
Vue.axios.defaults.headers.common["Cache-Control"] = "no-cache";
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

// mixin
Vue.mixin(Util)
Vue.mixin(utilityMixin)
Vue.mixin(DateUtil)
Vue.mixin(connServer)


moment.locale('ja');

/** */
Vue.filter('convertViewLocalDate', function (value) {
  if (value != null && value != "") {
    value = moment(value).format("YYYY/MM/DD");
  }
  return value
})
/** */
Vue.filter('convertViewLocalDateTime', function (value) {
  if (value != null && value != "") {
    value = value.replace("T"," ")
  }
  return value
})
/** */
Vue.filter('1000separator', function (value) {
  if (value != null && value != "") {
    let floatValue = parseFloat(value);
    return floatValue.toLocaleString();
  }
  return value
})



new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount("#work_manage");